// require('dotenv').config()
import axios from "axios";
import { constants } from "../utils/constants";

const api = (
  method,
  urlEndPoint,
  data = null,
  params = {},
  headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json; charset=UTF-8",
  }
) =>
  new Promise((myResolve) => {
    headers = {
      ...headers,
      Authorization: `Bearer ${constants.sendGrid}`,
    };
    axios({
      method,
      url: urlEndPoint,
      data,
      headers,
      params,
    })
      .then((response) => {
        myResolve({
          message: response.data.message,
          data: response.data.data,
          success: response.data.success,
        });
      })
      .catch((err) => {
        if (err.response) {
          myResolve({
            message: err.response.data.message,
            data: err.response.data.data,
            success: err.response.data.success,
          });
        } else {
          myResolve({
            message: err.toString(),
            data: { ...err },
            success: false,
          });
        }
      });
  });

export default api;
